module.exports = __webpack_public_path__ + "static/20220818.256fe207.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20220818.png
// module id = 997
// module chunks = 2